/*
 * Copyright (c) 2021 LucidResolutions LLC. All rights reserved.
 */

import React from "react";

import InitInterceptors from "./interceptor";
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import {AuthServiceProvider} from "./context/auth.context";
import {ExternalLayout} from "./layout/external.layout";
import {Login} from "./page/login/login";
import {Register} from "./page/register/register";
import {InternalLayout} from "./layout/internal.layout";
import {ExchangeProvider} from "./context/exchange.context";
import {Result} from "antd";
import {ProfilePage} from "./page/profile/profile.page";
import {TacticsPage} from "./page/tactics/tactics.page";
import {BasketsPage} from "./page/baskets/baskets.page";
import {SettingsPage} from "./page/settings/settings.page";
import {AllocationsPage} from "./page/baskets/allocations.page";
import {ForgotPasswordPage} from "./page/forgot-password/forgot.password.page";
import {ResetPasswordPage} from "./page/forgot-password/reset.password.page";
import {ClockCircleOutlined} from "@ant-design/icons";
import {PublicDefenderPage} from "./page/public-defender/public-defender.page";
import {DashboardPage} from "./page/dashboard/dashboard.page";
import {DefenderPage} from "./page/defender/defender.page";

function NotFound(){
    return <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
    />
}

function UnderConstruction() {
    return <Result
        icon={<ClockCircleOutlined />}
        title="Under Construction"
        subTitle="We are working deligently to make this live come back soon!"
    />
}

function App() {
  InitInterceptors()
  return (
      <AuthServiceProvider>
          <Router>
            <Switch>
                <ExternalLayout key='login' path={'/login'} component={Login}/>
                <ExternalLayout key='public-defender' path={'/public-defender'} component={PublicDefenderPage}/>
                <ExternalLayout key='register' path={'/register'} component={Register}/>
                <ExternalLayout key='forgot' path={'/forgot'} component={ForgotPasswordPage}/>
                <ExternalLayout key='reset' path={'/reset'} component={ResetPasswordPage}/>
                <InternalLayout key={'dashboard'} exact path={'/'} component={DashboardPage}/>
                <InternalLayout  key={'settings'} exact path={'/settings'} component={SettingsPage}/>
                <Route component={UnderConstruction}/>
            </Switch>
          </Router>
      </AuthServiceProvider>
  );
}

export default App;
